//#region Imports
import * as React from "react";
import type { IAnydoAuth } from "@anydo/interfaces";
//#endregion

export const AuthServiceContext = React.createContext<IAnydoAuth>(undefined!);
if (__DEV__) AuthServiceContext.displayName = "AuthServiceContext";
